module.exports = __webpack_public_path__ + "static/img/dress_left_red.68917d2f.png";